import React from 'react';
import styles from '../../Styles/Modules/Checkbox.module.scss';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { ImCheckmark } from 'react-icons/im';
import { playSound } from '../../State/Slices/soundsSlice';
import { SOUND_NAME } from '../../sounds'; // Use .module.scss for SCSS modules

const Checkbox = ({ label, state, action }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <div className={styles.checkbox}>
      <label className={styles.checkboxLabel}>
        {t(label)}

        <input
          className={styles.checkboxInput}
          type="checkbox"
          checked={state}
          onChange={() => {
            dispatch(playSound(SOUND_NAME.click));
            action && dispatch(action());
          }}
        />

        <span className={styles.checkboxCheckmark}>
        <ImCheckmark
          className={`${styles.checkboxIcon} ${state ? styles.checkboxIconActive : ''}`}/>
        </span>
      </label>
    </div>
  );
};

export default Checkbox;
